export class MapToolManager {
  constructor(onChange = () => {}) {
    this.tools = new Map()
    this.activeId = 'pan'
    this.onChange = onChange
  }
  register(tool) { this.tools.set(tool.id, tool) }
  activate(id) {
    if (!this.tools.has(id) || this.activeId === id) return
    const current = this.tools.get(this.activeId)
    if (current && current.deactivate) current.deactivate()
    this.activeId = id
    const next = this.tools.get(id)
    if (next && next.activate) next.activate()
    this.onChange(id)
  }
  cancel() { this.activate('pan') }
  handle(method, payload) {
    const active = this.tools.get(this.activeId)
    return active && typeof active[method] === 'function' ? active[method](payload) : undefined
  }
}
